"use client";

import clsx from "clsx";
import classes from "./home-video-embed.module.css";

export interface HomeVideoEmbedFeature {
  id: string;
  title: string;
}

interface HomeVideoEmbedProps {
  activeFeature: string;
  features: HomeVideoEmbedFeature[];
  vimeoIds: Record<string, string>;
}

export default function HomeVideoEmbed({
  activeFeature,
  features,
  vimeoIds,
}: HomeVideoEmbedProps) {
  return (
    <>
      {features.map((feature) => {
        const isActive = activeFeature === feature.id;

        return (
          <div
            key={feature.id}
            className={clsx(
              classes.vimeoEmbedContainer,
              isActive ? classes.vimeoEmbedVisible : classes.vimeoEmbedHidden
            )}
          >
            <div className={classes.vimeoEmbedWrap}>
              <iframe
                src={`https://player.vimeo.com/video/${
                  vimeoIds[feature.id]
                }?quality=720p&background=1`}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                className={classes.vimeoIframe}
                title={`${feature.title} Preview`}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}
